import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IRhRepository } from "../../repositories/rh_repository";
import { BiometriaFacial } from "../../models/biometria_facial";
import { IGetBiometriaFacialVisualizarUseCase } from "../../../presentation/useCases/read/get_biometria_facial_visualizar_use_case";


export class GetBiometriaFacialVisualizarUseCase extends BasePaginatedUseCase<BiometriaFacial> implements IGetBiometriaFacialVisualizarUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getBiometriaFacialVisualizar(
    idBiometriaFacial: number,
    nomeImagem: string,
  ): Promise<string> {
    const rawBlob = await this.repository.getBiometriaFacialVisualizar(idBiometriaFacial);

    const imageBlob = new Blob([rawBlob], { type: 'image/jpeg' });
    
    return window.URL.createObjectURL(imageBlob); 
  }
}